import usFlag from 'flag-icons/flags/4x3/us.svg';
import mxFlag from 'flag-icons/flags/4x3/mx.svg';

/**
 * Per-language presentation metadata, shared by every language-selection
 * surface (the dropdown `LanguageSwitcher` and the header `HeaderLanguageButton`
 * popover). Each control iterates `SUPPORTED_LANGUAGES` and renders whatever
 * entries appear here — codes without a row fall back to a generic label, a
 * clear "wire me up" signal for whoever adds the next language.
 *
 * Adding a language: add a flag SVG import + a row here + bump
 * `VITE_SUPPORTED_LANG`. No other code changes — this is the single source of
 * truth for flag + native name.
 *
 * The flag SVGs come from `flag-icons` (lipis/flag-icons), imported via Vite's
 * static-asset URL handling — each `import usFlag from '...'` returns a hashed
 * URL string served from `/assets/`. The map key is the BCP-47 tag (canonical
 * case), so the flag matches the locale region: `en` → US, `es-MX` → MX.
 */
export const LANGUAGE_META: Record<string, { flag: string; nativeName: string }> = {
  en: { flag: usFlag, nativeName: 'English' },
  'es-MX': { flag: mxFlag, nativeName: 'Español' },
};
